import { LoaderFunctionArgs, redirect } from 'react-router';

import { signInStep2UseReceivedCodeToLogin } from '@/domain/auth/actions/sign-in-step2-use-received-code-to-login.action';
import { signOutUser } from '@/domain/auth/actions/sign-out-user.action';
import { store } from '@/domain/store';

import { prepareAuth } from '../../loaders/prepare-auth-loader';

/**
 * If the user in connected and tries to access `/`, we redirect to `/app`
 * If the user in NOT connected and tries to access `/`, we redirect to `/login`
 */
export async function rootIndexLoader() {
  const { userIsConnected } = await prepareAuth();
  // const hasAccess = await checkUserAccess();

  if (userIsConnected) {
    return redirect('/app');
  } else {
    return redirect('/login');
  }
}

/**
 * If the user is connected and tries to access `/login`,
 * we redirect to `/app`
 */
export async function loginLoader() {
  const { userIsConnected } = await prepareAuth();

  if (userIsConnected) {
    return redirect('/app');
  }

  return null;
}

/**
 * If the user open `/logout`,
 * we trigger signOut action
 */
export async function logoutLoader() {
  await prepareAuth({ validateTokenByApiCall: false });
  try {
    await store.dispatch(signOutUser()).unwrap();
    return redirect('/login');
  } catch {
    return redirect('/');
  }
}

/**
 * Specific route used for signIn auth process.
 * We get a `code` and send an action to continue signIn process.
 * Then we redirect to `/`. The next route will check if user is authenticated or no.
 */
export async function authLoader({ request }: LoaderFunctionArgs) {
  const url = new URL(request.url);
  const receivedCode = url.searchParams.get('code');
  if (!receivedCode) {
    return redirect('/login');
  }
  try {
    await store
      .dispatch(signInStep2UseReceivedCodeToLogin(receivedCode))
      .unwrap();
  } catch (error) {
    console.error(error);
  }
  return redirect('/');
}
